import { Link, useLocation } from 'react-router-dom'
import { AlertTriangle, ExternalLink } from 'lucide-react'
import useAuthStore from '@/store/useAuthStore'
import useGetBillingSubscription from '@/services/api/billing/useGetBillingSubscription'

/**
 * App-wide strip shown while the space is past due — it keeps full access for
 * the retry window, but the card needs fixing before Stripe marks it unpaid.
 */
export default function PaymentIssueBanner() {
  const location = useLocation()
  const currentTeamId = useAuthStore((s) => s.currentTeamId)
  const { data } = useGetBillingSubscription({ teamId: currentTeamId })

  const sub = data?.subscription
  if (!sub?.payment_issue || location.pathname === '/billing') return null

  return (
    <div
      role="alert"
      className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1 border-b border-red-200 bg-red-50 px-3 py-1.5 text-sm text-red-900"
    >
      <AlertTriangle className="size-4 shrink-0" />
      <span className="min-w-0 flex-1">
        A payment for this space failed.{' '}
        {data?.is_billing_owner
          ? 'Pay the open invoice to avoid losing access.'
          : 'Ask the space owner to update the payment details.'}
      </span>
      {data?.is_billing_owner && (
        <span className="flex shrink-0 gap-3 font-medium">
          {sub.pay_invoice_url && (
            <a
              href={sub.pay_invoice_url}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 underline"
            >
              Pay now
              <ExternalLink className="size-3" />
            </a>
          )}
          <Link to="/billing" className="underline">
            Billing
          </Link>
        </span>
      )}
    </div>
  )
}
